<template>
  <FavouriteBtn
    v-ripple
    :class="isMobile ? 'rounded-15' : 'rounded-20'"
    type="lpu"
    :size="isMobile ? 36 : 52"
    :target-id="lpuId"
  />
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import FavouriteBtn from 'src/components/common/FavouriteBtn/FavouriteBtn.vue'

defineProps<{
  lpuId: number
}>()

const isMobile = useIsMobile()
</script>
